import { socket } from '@/main';
import { PlatesSteps } from '@/common/variables';
import { disabledStepsFlow, stepsFlow } from '@/common/stepsFlow';
import { needs, disease } from '@/common/platesData';
import { merge } from 'lodash';

const platesQuestions = [
  {
    step: PlatesSteps.intro,
    data: {
      isLifeInsurance: false,
      isPropertiesCorrect: false,
      benefits: [],
    },
  },
  {
    step: PlatesSteps.occupation,
    data: {
      occupation: null,
      key: null,
    },
  },
  {
    step: PlatesSteps.disabledAnalysis,
    data: {
      isAgreeWithAmount: false,
      isAgreeWithRelationship: false,
      isAgreeWithTakeCare: false,
      isReplacementAsked: false,
      isAgreeWithBeneficiary: false,
      isAgreeWithBeneficiaryCare: false,
      isLiveInSameState: false,
      isGiveAnyGrandkids: false,
      isStatusConfirm: false,
    },
  },
  {
    step: PlatesSteps.disabledNeeds,
    data: {
      isAgree: false,
      isKnow: false,
      isHelp: false,
    },
  },
  {
    step: PlatesSteps.analysis,
    data: {
      isAgreeWithMainNeed: false,
      isAgreeWithBeneficiary: false,
      isHasMoney: false,
      isTakeCare: false,
      isReplacementAsked: false,
    },
  },
  {
    step: PlatesSteps.needs,
    data: {
      isMainNeedsAsked: false,
      isBeneficiaryAsked: false,
      isProtectedAsked: false,

      isFinalExpenses: false,
      isFamilyProtection: false,
      isDebtProtection: false,
      isMortgageProtection: false,
    },
  },
  {
    step: PlatesSteps.process,
    data: {
      isQuestionsAsked: false,
      isAgentConfirm: false,
    },
  },

  //second flow plates
  {
    step: PlatesSteps.basicInfo,
    data: {
      isParamsAsked: false,
      test1: false,
    },
  },
  {
    step: PlatesSteps.health,
    data: {
      prosperity: {
        q1: false,
        q2: false,
        q3: false,
        q4: false,
        q5: false,
      },
      liberty: {
        notCompletedHospitalization: false,
        unableToCare: false,
        oxygenCondition: false,
        organTransplant: false,
        immuneSystem: false,
        heartFailure: false,
        dementia: false,
      },
    },
  },
  {
    step: PlatesSteps.disabledHealthFirst,
    data: {
      prosperity: {
        q1: false,
        q2: false,
        q3: false,
        q4: false,
        q5: false,
      },
      liberty: {
        isAngina: false,
        isParalysis: false,
        isCancer: false,
        isDiabetic: false,
        isHepatitis: false,
        isParkinson: false,
        isFelony: false,
      },
    },
  },
  {
    step: PlatesSteps.disabledHealthSecond,
    data: {
      prosperity: {
        q1: false,
        q2: false,
        q3: false,
      },
      liberty: {
        isChronic: false,
        isHeartbeat: false,
        isEpileptic: false,
      },
    },
  },
  {
    step: PlatesSteps.generalHealth,
    data: {
      isAnyHeart: false,
      isRespiratoryOperations: false,
      isMaintenanceConditions: false,
    },
  },
  {
    step: PlatesSteps.company,
    data: {
      isHelpAsked: false,
      isQualifyAsked: false,
      isCompanyRatingAsked: false,
    },
  },
  {
    step: PlatesSteps.product,
    data: {
      isProduct: false,
      isAllows: false,
      isIncreases: false,
      isOffers: false,
      isCertificate: false,

      isFexProduct: false,
      isFexValue: false,
      isFexIncrease: false,
      isFexBenefit: false,
      isFexAccelerated: false,
      isFexCover: false,
      isFexSchedule: false,
    },
  },
  {
    step: PlatesSteps.result,
    data: {
      isCorrectAsked: false,
      isCorrect: false,
      isTold: false,
      isCoverage: false,
      company: null,
      monthlyPremium: 0,
    },
  },
  {
    step: PlatesSteps.email,
    data: {
      isEmailAsked: false,
      isAddressAsked: false,
      isPhysicianAsked: false,
      isSocialAsked: false,

      address: null,
      physician: null,
      social: null,
    },
  },
  {
    step: PlatesSteps.beneficiary,
    data: {
      isPrimaryBeneficiary: false,
      isContingentBeneficiary: false,
      contingentBeneficiary: false,
      isClaim: false,
      isEnsure: false,
      isSense: false,
    },
  },
  {
    step: PlatesSteps.payment,
    data: {
      isNeedProtect: false,
      protect: false,
      isAccount: false,
      account: null,
    },
  },
  {
    step: PlatesSteps.summary,
    data: {
      testSummary: false,
    },
  },
];

export default {
  namespaced: true,
  state: {
    step: PlatesSteps.intro, //set initial step here
    isDisabledBranch: false, //disabled / employee branch
    beneficiary: {
      //Todo replace LEAD beneficiary
      relationship: null,
      name: null,
      status: null,
      anyChild: false,
      grandchildrenAmount: null,
      liveInSameState: null,
    },

    bankDetails: {
      isDraft: false,
      draft: {
        name: null,
        routing: null,
        account: null,
      },
      card: {
        card: null,
        expirationMonth: null,
        expirationYear: null,
        security: null,
        zip: null,
      },
    },
    needs,
    disease,
    stepsFlow,
    disabledStepsFlow,
    info: platesQuestions,
    appQuestion: 'prosperity_life',
    appRate: null,
  },
  mutations: {
    setPlates(state, payload) {
      state = merge(state, payload);
    },
    setStep(state, payload) {
      state.step = payload;
    },
    setBeneficiary(state, payload) {
      state.beneficiary = payload;
    },
    setBankDetails(state, payload) {
      state.bankDetails = payload;
    },
    setBranch(state, payload) {
      state.isDisabledBranch = payload;
    },
    setAppQuestion(state, payload) {
      state.appQuestion = payload;
    },
    setAppRate(state, payload) {
      state.appRate = payload;
    },
  },
  getters: {
    step: (state) => state.step,
    branch: (state) => state.isDisabledBranch,
    beneficiary: (state) => state.beneficiary,
    bankDetails: (state) => state.bankDetails,
    dataByStep: (state) => (step) => state.info.find((i) => i.step === step),
    needs: (state) => state.needs,
    needsList: (state) => {
      return Object.keys(state.needs).filter(
        (key) => state.needs[key].isSelected
      );
    },
    disease: (state) => state.disease,
    selectedDisease: (state) => {
      return Object.keys(state.disease).filter(
        (key) => state.disease[key].isSelected
      );
    },
    stepsFlow: (state) => {
      return state.isDisabledBranch ? state.disabledStepsFlow : state.stepsFlow;
    },
    appQuestion: (state) => state.appQuestion,
    appRate: (state) => state.appRate,
  },
  actions: {
    updatePlate({state}, payload) {
      socket.emit('store-plate', {
        lead_id: payload.id,
        plates: JSON.stringify(state)
      });
    },
  },
};
